import { EMAIL, FIRST_NAME, LAST_NAME, PHONE, WORKFLOWMAX_COMPANY } from 'constants/proposalCustomerFieldTypes'
import { ABSTRACT_SERVICE, SCHEDULED_SERVICE, SINGLE_EVENT } from 'constants/proposalTypes'
import {
  WHEN_EVENT, WHEN_SERVICE, INSTANT_LINK, MESSAGE,
  PRICE, DURATION, DESCRIPTION,
  LOCATION, LOCATION_CHOICE, LOCATION_SUGGEST,
  INSTANT_NEWSLETTER_SUBSCRIBE,
  LIVE_CHAT, LIVE_CHAT_WELCOME_MESSAGE, LIVE_CHAT_AWAY_MESSAGE, LIVE_CHAT_REQUIRE_USER_INFO,
  MINDBODY, WORKFLOWMAX
} from 'constants/proposalFieldTypes'
import { BUILD_EVENT_PERMISSION } from 'selectors/permissions'

export const messageFieldTemplate = {
  type: MESSAGE,
  label: 'Message',
  placeholder: 'Add a message or question here...'
}

export const locationFieldTemplate = {
  type: LOCATION,
  label: 'Where',
}

export const locationChoiceFieldTemplate = {
  type: LOCATION_CHOICE,
  label: 'Select a location',
}

export const locationSuggestFieldTemplate = {
  type: LOCATION_SUGGEST,
  label: 'Where',
  placeholder: 'Suggest a location...'
}

export const liveChatWelcomeMessageFieldTemplate = {
  type: LIVE_CHAT_WELCOME_MESSAGE,
  value: 'Hi, I\'m here if you have any questions!',
}

export const liveChatAwayMessageFieldTemplate = {
  type: LIVE_CHAT_AWAY_MESSAGE,
  value: 'Hi there 👋 we’re not online right now but leave a message and your email and we’ll get back to you right away!',
}

export const mindbodyFieldTemplate = {
  type: MINDBODY,
  label: 'Class',
}

export const workflowMaxCompanyCustomerFieldTemplate = {
  type: WORKFLOWMAX_COMPANY,
  label: 'Company name'
}

export const customerFieldsLabel = 'Enter your details'

export default [
  {
    name: 'Live chat',
    type: ABSTRACT_SERVICE,
    data: {
      fields: [
        { type: LIVE_CHAT },
        liveChatWelcomeMessageFieldTemplate,
        liveChatAwayMessageFieldTemplate,
        { type: LIVE_CHAT_REQUIRE_USER_INFO },
      ]
    }
  },
  {
    name: 'Contact me',
    type: ABSTRACT_SERVICE,
    data: {
      fields: [
        messageFieldTemplate,
        { type: DESCRIPTION },
      ],
      customerFields: [
        { type: FIRST_NAME },
        { type: LAST_NAME },
        { type: EMAIL },
        { type: PHONE },
      ],
      customerFieldsLabel,
      forbiddenFields: [WHEN_SERVICE, WHEN_EVENT, PRICE, DURATION, LOCATION, LOCATION_CHOICE],
    }
  },
  {
    name: 'Book me',
    type: SCHEDULED_SERVICE,
    data: {
      fields: [
        { type: WHEN_SERVICE },
        messageFieldTemplate,
        { type: DESCRIPTION },
      ],
      customerFields: [
        { type: FIRST_NAME },
        { type: LAST_NAME },
        { type: EMAIL },
        { type: PHONE },
      ],
      customerFieldsLabel,
      forbiddenFields: [WHEN_EVENT],
    }
  },
  {
    name: 'Schedule a meeting',
    type: SCHEDULED_SERVICE,
    data: {
      fields: [
        { type: WHEN_SERVICE },
        messageFieldTemplate,
        { type: DESCRIPTION },
      ],
      customerFields: [
        { type: FIRST_NAME },
        { type: LAST_NAME },
        { type: EMAIL },
        { type: PHONE },
      ],
      customerFieldsLabel,
      forbiddenFields: [WHEN_EVENT],
    }
  },
  {
    name: 'Event',
    requirePermission: BUILD_EVENT_PERMISSION,
    type: SINGLE_EVENT,
    selectOnlyDate: true,
    data: {
      fields: [
        { type: WHEN_EVENT },
        messageFieldTemplate,
        { type: DESCRIPTION },
      ],
      customerFields: [
        { type: FIRST_NAME },
        { type: LAST_NAME },
        { type: EMAIL },
        { type: PHONE },
      ],
      customerFieldsLabel,
      forbiddenFields: [WHEN_SERVICE],
    }
  },
  {
    name: 'Quick link',
    type: ABSTRACT_SERVICE,
    data: {
      fields: [
        { type: INSTANT_LINK }
      ],
    }
  },
  {
    name: 'Subscribe to our newsletter',
    type: ABSTRACT_SERVICE,
    data: {
      fields: [
        { type: INSTANT_NEWSLETTER_SUBSCRIBE },
      ],
      customerFields: [
        { type: FIRST_NAME },
        { type: LAST_NAME },
        { type: EMAIL },
      ],
      customerFieldsLabel,
    }
  },
  {
    name: 'Mindbody classes',
    type: ABSTRACT_SERVICE,
    data: {
      fields: [
        mindbodyFieldTemplate,
      ],
      customerFields: [
        { type: FIRST_NAME },
        { type: LAST_NAME },
        { type: EMAIL },
      ],
      customerFieldsLabel,
    }
  },
  {
    name: 'WorkflowMax',
    type: SCHEDULED_SERVICE,
    data: {
      fields: [
        { type: WHEN_SERVICE },
        messageFieldTemplate,
        { type: DESCRIPTION },
        { type: WORKFLOWMAX },
      ],
      customerFields: [
        workflowMaxCompanyCustomerFieldTemplate,
        { type: FIRST_NAME },
        { type: LAST_NAME },
        { type: EMAIL },
        { type: PHONE },
      ],
      customerFieldsLabel,
      forbiddenFields: [WHEN_EVENT],
    }
  },
  {
    name: 'Start from scratch',
    type: ABSTRACT_SERVICE,
    data: {
      fields: [
        { type: DESCRIPTION },
      ],
      customerFields: [
        { type: FIRST_NAME },
        { type: LAST_NAME },
        { type: EMAIL },
        { type: PHONE },
      ],
      customerFieldsLabel,
    }
  }
]
